import { Cookie } from '@libs';

export const getGaId = () => {
  try {
    const gaId = Cookie.get(null, '_ga');

    if (gaId) {
      return gaId.split('.').slice(-2).join('.');
    }

    return 'nid';
  } catch (error) {
    console.error(error);

    return 'nid';
  }
};

export const setDownloadLinkAfterGaId = (callback, countReq = 1) => {
  if (countReq === 1) {
    callback();
  }

  if (countReq >= 240 * 3) return; // 240 это минута

  try {
    const gaId = getGaId();

    if (gaId && gaId !== 'nid') {
      callback();
    } else {
      setTimeout(() => {
        setDownloadLinkAfterGaId(callback, countReq + 1);
      }, 250);
    }
  } catch (error) {
    console.error(error);

    return callback();
  }
};

/* get download link with ga id */
export const getDownloadLinkWithGaId = (linkDownload) => {
  const getFilenameAndExtension = (url) => {
    const urlObject = new URL(url);
    const filenameFromParam = urlObject.searchParams.get('downloadfilename');

    const filenameWithExtension = filenameFromParam || urlObject.pathname.split('/').pop();
    const lastDotIndex = filenameWithExtension.lastIndexOf('.');

    if (lastDotIndex !== -1) {
      const filename = filenameWithExtension.substring(0, lastDotIndex);
      const extension = filenameWithExtension.substring(lastDotIndex + 1);

      return { filename, extension };
    }

    return { filename: filenameWithExtension, extension: '' };
  };

  try {
    const ga = getGaId();
    const link = linkDownload.split('?')[0];
    const { filename, extension } = getFilenameAndExtension(linkDownload);
    const index = filename.indexOf('_');
    const filenameUpdate =
      index === -1
        ? filename
        : filename.slice(0, index) + filename[index + 1].toUpperCase() + filename.slice(index + 2);

    return `${link}?downloadfilename=${filenameUpdate.replaceAll('_', '')}_${ga}.${extension}`;
  } catch (error) {
    console.error(error);

    return linkDownload;
  }
};

export const sendEventFileDownload = (event, link) => {
  try {
    const target = event.currentTarget || event.target || {};
    const ga = getGaId();
    const filename = event ? target.href.split('/').pop() : '';
    const index = filename.indexOf('_');
    const filenameUpdate =
      index === -1
        ? filename
        : filename.slice(0, index) + filename[index + 1].toUpperCase() + filename.slice(index + 2);
    const lastDotIndex = filenameUpdate.lastIndexOf('.');
    const fullFileName = filenameUpdate
      ? filenameUpdate.substring(0, lastDotIndex) + '_' + ga + filenameUpdate.slice(lastDotIndex)
      : 'error';

    window.dataLayer &&
      window.dataLayer.push({
        event: 'ga4_Event',
        evName: 'file_download',
        FileExtension: filenameUpdate.slice(lastDotIndex + 1),
        FileName: fullFileName,
        ClickURL: link,
        ClickText: target.innerText,
      });
  } catch (error) {
    console.error(error);
  }
};

const findByPropertyNodeElement = (element, property, depth = 5) => {
  let current = element;
  let level = 0;

  while (current && level < depth) {
    if (current[property]) {
      return current;
    }

    current = current.parentNode;
    level++;
  }

  return {}; // Если не нашли элемент с `url`
};

const getTarget = (event, requireProperty = 'href') => {
  const target = event.currentTarget || event.target || null;

  if (!target[requireProperty]) {
    return findByPropertyNodeElement(target, requireProperty);
  }

  return target;
};

export const handleClickDownload = (event, attempt = 0) => {
  event.preventDefault();

  const target = getTarget(event);

  const MAX_ATTEMPT = 60;

  if (attempt >= MAX_ATTEMPT) {
    window.location.href = target.href;

    return;
  }

  try {
    const urlObject = new URL(target.href);
    const ga = getGaId();

    if (
      urlObject.search &&
      urlObject.search.indexOf('downloadfilename=') !== -1 &&
      urlObject.search.indexOf('_nid.') === -1
    ) {
      sendEventFileDownload(event, target.href);
      window.location.href = target.href;
      return;
    }

    if (!ga || ga === 'nid') {
      return setTimeout(() => {
        handleClickDownload(event, attempt + 1);
      }, 1000);
    }

    const link = getDownloadLinkWithGaId(target.href);

    sendEventFileDownload(event, link);
    window.location.href = link;
  } catch (error) {
    console.error(error);
    sendEventFileDownload(event, target.href);
    window.location.href = target.href;
  }
};

export const generateRandomString = (stringLength) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';

  for (let i = 0; i < stringLength; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
};

export const encodeParams = (params) => {
  return encodeURIComponent(JSON.stringify(params));
};

export const decodeParams = (encoded) => {
  try {
    return JSON.parse(decodeURIComponent(encoded));
  } catch {
    try {
      return JSON.parse(atob(encoded));
    } catch {
      return {};
    }
  }
};

export const downloadPlanoplanContextHandler = (e) => {
  try {
    e.stopPropagation();
    const targetUrl = e.currentTarget.href;
    const innerText = e.currentTarget.innerText;
    window.dataLayer &&
      window.dataLayer.push({
        event: 'ga4_Event',
        evName: 'download_button_rightclick',
        ClickURL: targetUrl,
        ClickText: innerText,
      });
  } catch (error) {
    console.error(error);
  }
};

export const downloadPlanoplanAuxHandler = (e) => {
  try {
    if (e.button !== 1) return;
    const targetUrl = e.currentTarget.href;
    const innerText = e.currentTarget.innerText;
    const fileName = targetUrl.split('/').pop();
    const fileExtension = fileName.split('.').pop();
    window.dataLayer &&
      window.dataLayer.push({
        event: 'ga4_Event',
        evName: 'download_button_middleclick',
        ClickURL: targetUrl,
        ClickText: innerText,
        FileExtension: fileExtension,
        FileName: fileName,
      });
  } catch (error) {
    console.error(error);
  }
};
